// extracted by extract-css-chunks-webpack-plugin
module.exports = {"block":"app-components-kit-waveform-loopblock--block"};